import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

const dividerStyles = css({
	margin: `0px ${token('space.300', '24px')}`,
	alignSelf: 'stretch',
	width: '1.4px',
	backgroundColor: token('color.border', '#7D818A'),
});

export const Divider = () => {
	return <div css={dividerStyles} />;
};
